import { AbilityBuilder, createMongoAbility } from '@casl/ability'

export function defineAbilityFor(user) {
  const { can, cannot, build } = new AbilityBuilder(createMongoAbility);
  //console.log("ABILITY USER: ", user)

  can("read", "order");

  if (user.role === "admin") { // ADMIN
    can("manage", "all");

    can("manage", "CustomerImport");
    can("manage", "ProductImport");
    
  }

  if (user.role === "manager") { // MANAGER
    can("view", "AdministrationMenu");
    can("view", "BusinessIntelligenceMenu");

    can("manage", "Products");
    can("manage", "BranchProductMappings");
    can("manage", "POImportConfig");
    can("manage", "LogisticsConfig");
    
    can("edit", "PurchaseOrder"); // edit PO
    can("reject", "PurchaseOrder"); // reject PO
    can("zero", "PurchaseOrderItem"); // set PO item to 0

    can("manage", "PurchaseOrderImport");
    can("manage", "PurchaseOrderPending");

    can("view", "PurchaseOrderReport");
    can("view", "ProductSortOrder");
    
  }

  if (user.role === "supervisor") { // SUPERVISOR
    can("view", "AdministrationMenu");
    can("view", "BusinessIntelligenceMenu");

    can("manage", "BranchProductMappings");
    can("manage", "LogisticsConfig");

    can("edit", "PurchaseOrder"); // edit PO
    can("zero", "PurchaseOrderItem"); // set PO item to 0

    can("manage", "PurchaseOrderImport");
    can("manage", "PurchaseOrderPending");

    can("view", "PurchaseOrderReport");
  }

  if (user.role === "general") { // GENERAL
    can("edit", "PurchaseOrder");
    can("manage", "PurchaseOrderImport");
    can("manage", "PurchaseOrderPending");
  }

  if (user.isLogin) {
    can("read", "profile");
    can(["create", "update"], "article");
    cannot("create", "profile");
  }

  return build();
}